import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import Animate from '../../../../components/Animate';
import TaskCompletionStep from './TaskCompletionStep';
import dataModel from '../../../../models/DataModel';

import './TaskCompletionSteps.scss';

export class TaskCompletionSteps extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      addingNewStep: false,
      expanded: true,
      scrollPosition: localStorage.getItem('scrollPositionTasks') && localStorage.getItem('scrollPositionTasks')!= 0?localStorage.getItem('scrollPositionTasks'):0,
      setOriginalHeight: true,
      isQuickActionAnimating: false,
    };
    //this.myRef = React.createRef()
    this.currentUserTaskRole = this.getCurrentUserTaskRole();
    this.handleClickScroll = this.handleClickScroll.bind(this);
    this.draggableCC = {};
  }
  componentDidMount() {
    
    var scrollPosition = localStorage.getItem('scrollPositionCompletionStep');

    if (this.scrollContainer) {
      this.scrollContainer.scrollTop = scrollPosition;   
      this.scrollContainerTop=  scrollPosition;
    }

  }

  componentDidUpdate() {
    // this.scrollWhileDragging =  this.scrollWhileDragging || {}
    // this.scrollWhileDragging.scrollTop = 0
    this.currentUserTaskRole = this.getCurrentUserTaskRole();

    if (this.scrollContainer) {
      this.scrollContainer.scrollTop = this.scrollContainerTop;
    }
  
  }

  handleContract() {
    if (this.state.expanded || this.state.setOriginalHeight) {
      this.setState({ animateContract: true });
    }
  }

  handleExpand() {
    if (!this.state.expanded) {
      this.setState({ expanded: true, animateExpand: true });
    }
  }

  handleFinishAnimation() {
    if (this.state.expanded && this.state.animateContract) {
      this.setState({
        animateContract: false,
        expanded: false,
        setOriginalHeight: false,
      });
    } else {
      this.setState({ animateExpand: false });
    }
  }

  handleSlideout(slideoutCSId){
    if (slideoutCSId){
      this.setState({ activeSlideoutId: slideoutCSId });
    }
    else{
      this.setState({ activeSlideoutId: null });
    }
  }

  createCompletionStepList() {
    const { task } = this.props;
    const { addingNewStep, activeSlideoutId } = this.state;
    this.completionStepTotalHeight = 0;
    const cc_count = task.completion_criteria;
    this.countSteps=cc_count.length;
    const length = task.completion_criteria
      ? task.completion_criteria.length
      : 0;
    if (length.length == 0 && !addingNewStep) {
      this.completionStepTotalHeight += 15;
      return (
        <div className="no-steps-found">{'No Completion Steps found.'}</div>
      );
    } else {
      return task.completion_criteria.map((cc, index) => {
        if (cc){
          this.completionStepTotalHeight += 62;
          this.draggableCC[cc.id ? cc.id : cc] = cc;
          return (
              <TaskCompletionStep
                id={cc.id ? cc.id : cc}
                pmCanEdit={this.props.pmCanEdit}
                task={task}
                completionStep={cc.id ? cc : null}
                activeSlideoutId={activeSlideoutId}
                handleSlideout={this.handleSlideout}
                key={'completionStep' + (cc.id ? cc.id : cc)}
                firstInList={index == 0}
                handleDeleteCompletionStep={this.handleDeleteCompletionStep}
                handleDragging={this.handleDragging}
                handleDropping={this.handleDropping}
                handleDragCancel={this.handleDragCancel}
                enableDragDrop={!addingNewStep}
                userStepPermissions={this.props.userStepPermissions}
                handleClickScroll={this.handleClickScroll}
                isBuildOwner={this.props.isBuildOwner}
                buildOwnerEditing={this.props.buildOwnerEditing}
                displayPhotoCarousel={this.props.displayPhotoCarousel}
                isQuickActionAnimating={this.state.isQuickActionAnimating}
                handleIsQuickActionAnimating={this.handleIsQuickActionAnimating}
              />
            );
        }
        else{
          return false;
        }
      });
    }
  }

  /**
   * Revamped logic from <FieldUserTaskSettings>.
   * Returns a string representing the current user's role in the task.
   * Possible values are 'reviewer', 'approver', 'field_user', and 'notify'
   */
  getCurrentUserTaskRole() {
    const { task } = this.props;
    const currentUsersTaskAssignment = task.user_task_assignments ? task.user_task_assignments.filter(
      taskAssignment => {
        if (taskAssignment && !taskAssignment.toBeDeleted) {
          return taskAssignment.user_id == this.props.currentUser.id;
        }
        return false;
      }
    ) : [];
    return currentUsersTaskAssignment.length > 0 && currentUsersTaskAssignment[0]
      ? currentUsersTaskAssignment[0].assignment_type
      : null;
  }

  handleClickScroll(e){
    localStorage.setItem('scrollPositionCompletionStep', this.state.scrollPosition);
  };

  handleScroll(e){
    console.log(e.target);
    const scrollContainer = e.target;
    this.scrollContainerTop = scrollContainer.scrollTop;
    this.setState({
      scrollPosition: scrollContainer.scrollTop,
    });
    // if (localStorage.getItem("scrollPositionCompletionStep") == "0") {
    //   const scrollContainer = e.target;
    //   this.scrollContainerTop = scrollContainer.scrollTop;
    //   this.setState({
    //     scrollPosition: scrollContainer.scrollTop
    //   });
    // }else {
    //   var scrollPosition = localStorage.getItem("scrollPositionCompletionStep");
    //   localStorage.setItem('scrollPositionCompletionStep', 0);
    //   this.scrollContainerTop = scrollPosition;
    //   this.setState({
    //     scrollPosition: scrollPosition
    //   });

    // }
  
  }

  handleIsQuickActionAnimating(isQuickActionAnimating) {
    this.setState({ isQuickActionAnimating });
  }

  render() {
    const { task } = this.props;
    if (!task) {
      return null;
    }

    const {
      animateExpand,
      animateContract,
      expanded,
      setOriginalHeight,
    } = this.state;
    
    let animator = null;
    let containerSteps;
    let id = 'completion-step-list-' + task.id;
    let taskHeight;
    let completionStepList = null;
    if (expanded || setOriginalHeight) {
      completionStepList = this.createCompletionStepList();
    }
    if (animateExpand) {
      if(this.countSteps>5){
        taskHeight=400;
      }else if(this.countSteps==1 || this.countSteps==0){
        taskHeight=125;
      }
      else{
        taskHeight=this.countSteps*100;
      }
      // }else if(this.countSteps==0 ){
      //   taskHeight=62
      // }else if(this.countSteps==1 ){
      //   taskHeight=150
      // }
      // else{
      //   taskHeight=300
      // }
    
      let endVal = this.completionStepTotalHeight
        ? taskHeight 
        : 52;
      containerSteps= this.completionStepTotalHeight
        ? taskHeight -2
        : 52;
      let duration = 250;
      animator = (
        <Animate
          component_id={id}
          key="animate_expand"
          property={{ height: { startVal: 52, endVal: endVal } }}
          completionCallback={this.handleFinishAnimation}
          duration={duration}
        />
      );
    } else if (animateContract) {
      let duration = 250;
      animator = (
        <Animate
          component_id={id}
          key="animate_contract"
          property={{ height: { endVal: 52 } }}
          completionCallback={this.handleFinishAnimation}
          duration={duration}
        />
      );
    }

    // Edit/Add Completion Step
    
    if(this.countSteps>5){
      taskHeight=400;
    }else if(this.countSteps==1 || this.countSteps==0){
      taskHeight=125;
    }
    else{
      taskHeight=this.countSteps*100;
    }
    let style = setOriginalHeight
      ? {
        height: this.completionStepTotalHeight
            ? taskHeight
            : 52,
      }
      : { height: 52 };
    containerSteps = setOriginalHeight
      ? {
        height: this.completionStepTotalHeight 
            ? taskHeight-2
            : 52,
      }
      : { height: taskHeight };
    return (
      <div
     
        id={id}
        className="task-docs-container"
        style={ style }
      >
        {animator}
        <div  
        ref={el => this.scrollContainer = el}
             onScroll={this.handleScroll}  className="completion-step-container" style={containerSteps}>
          <div className={'completion-step-header '}>
            <div className={'title '}>
              COMPLETION STEPS
            </div>
              <div
                className="right-side"
                onClick={
                  expanded || setOriginalHeight
                    ? this.handleContract
                    : this.handleExpand
                }
              >
                {expanded || setOriginalHeight ? (
                  <div className="contractor" />
                ) : (
                  <div className="expandor" />
                )}
              </div>
          </div>
          <div
           
            className={'completion-step-list'}
            style={{ height: this.completionStepTotalHeight }}
          >
                {completionStepList}
          </div>
        </div>
      </div>
    );
  }
}

// TaskCompletionSteps.contextTypes = {
//   router: PropTypes.object.isRequired
// };

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps)(TaskCompletionSteps);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/TaskCompletionSteps/index.js